module.exports = __webpack_public_path__ + "img/b-1.4dd3b47.png";